/**
 * Turning what the server knows about a visitor's whereabouts and device into
 * words: a country code into a flag and a name, a device class into "Mobile".
 */

/** 🇹🇷 from "TR". Regional-indicator letters; any font with emoji draws the flag. */
export function flagOf(code: string | null | undefined): string {
  if (!code || !/^[A-Z]{2}$/i.test(code)) return "";
  const base = 0x1f1e6 - 65;
  return String.fromCodePoint(...[...code.toUpperCase()].map((c) => base + c.charCodeAt(0)));
}

/** "Türkiye" / "Turkey" from "TR", in the console's language; the code itself when the browser cannot name it. */
export function countryName(code: string | null | undefined, lang: "tr" | "en"): string | null {
  if (!code) return null;
  try {
    return new Intl.DisplayNames([lang], { type: "region" }).of(code.toUpperCase()) ?? code;
  } catch {
    return code;
  }
}

/** Flag and name together, or null when the country is unknown. */
export function placeLabel(code: string | null | undefined, lang: "tr" | "en"): string | null {
  const name = countryName(code, lang);
  return name ? `${flagOf(code)} ${name}`.trim() : null;
}

export type DeviceWords = { mobile: string; tablet: string; desktop: string };

/** "Mobil" for "mobile"; an unknown class is shown as it came, a missing one as null. */
export function deviceLabel(device: string | null | undefined, words: DeviceWords): string | null {
  if (!device) return null;
  return device in words ? words[device as keyof DeviceWords] : device;
}
